import React from 'react';
export const Footer = () => {
  return <footer className="w-full bg-gray-900 text-white py-4 px-4 text-center text-xs" data-id="element-261">
      <div className="max-w-4xl mx-auto" data-id="element-262">
        <p data-id="element-263">WOMEN'S HEALTH | Advertorial</p>
      </div>
    </footer>;
};